<template>
	<div class="list">
		<ul class="round" v-html="convertToList(items)"></ul>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
			required: false
		},
		items: {
			type: String,
			required: true
		}
	},
	methods: {
		convertToList(items) {
			return `<li class="body-text-1">${items.replace(
				/\r\n|\r|\n/gi,
				'</li><li>'
			)}</li>`;
		}
	}
};
</script>
<style lang="scss" scoped>
.round {
	padding: 0;
	::v-deep li {
		display: flex;
		list-style: none;

		&::before {
			content: ' \2022';
			color: #2cb6f8;
			margin-right: 10px;
		}
	}
}
</style>
